@if (formGroup) {
  <form class="flex flex-col" [formGroup]="formGroup">
    @for (
      conditionControl of conditionsFormArray?.controls;
      track conditionControl;
      let index = $index
    ) {
      <div
        class="flex gap-3 p-2"
        [ngClass]="index === 0 ? '' : 'border-t border-mediumColor'"
      >
        @if (conditionsFormArray.controls.length > 1) {
          <div>
            <div
              class="operand-box mt-2"
              [ngClass]="[
                'operand-box--' + logicalOperatorControl.value.toLowerCase(),
                index > 0 ? '' : 'invisible',
              ]"
            >
              {{ logicalOperatorControl.value }}
            </div>
          </div>
        }

        <div>
          <ng-container
            *ngTemplateOutlet="template; context: {$implicit: conditionControl}"
          ></ng-container>
        </div>
        @if (canDelete) {
          <div class="ml-auto">
            <em-button
              type="icon"
              icon="delete"
              color="warn"
              (btnClick)="removeCondition(index)"
            >
            </em-button>
          </div>
        }
      </div>
    }
    <div class="flex justify-center gap-3">
      @for (operator of availableOperators; track operator) {
        <em-button type="secondary" (btnClick)="addNewCondition(operator)">
          + {{ operator.toUpperCase() }}
        </em-button>
      }
    </div>
  </form>
}
